import { BaseReader } from "../base-reader";
import { OwnerTradingPointsRequestArgs, OwnerTradingPointsSchema } from "./trading-points.types";

export class TradingPointsReader extends BaseReader {
  /**
   * Get aggregated trading points for an owner across all their active subaccounts
   * @param ownerAddr The owner address to get trading points for
   * @returns The aggregated trading points with per-subaccount breakdown
   */
  async getByOwner({ ownerAddr, fetchOptions }: OwnerTradingPointsRequestArgs) {
    const queryParams = new URLSearchParams({ owner: ownerAddr });

    const response = await this.getRequest({
      schema: OwnerTradingPointsSchema,
      url: `${this.deps.config.tradingHttpUrl}/api/v1/points/trading/account`,
      queryParams,
      options: fetchOptions,
    });

    return response.data;
  }
}
